import React from 'react';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import styles from './OldPayerP2P.css';

export default function NewPayerP2P(){
const codestyle={backgroundColor: 'lightgray', overflowX: 'auto'};

const memberMatchBody={
  "resourceType": "Parameters",
  "parameter": [
    {
      "name": "MemberPatient",
      "resource": {
        "resourceType": "Patient",
        "name": [{ "family": "5482LNAME", "given": ["5482FNAME"] }],
        "birthDate": "1960-01-01",
        "identifier": [{
          "type": { "coding": [{ "code": "MB" }] },
          "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
          "value": "202818102"
        }]
      }
    },
    {
      "name": "CoverageToMatch",
      "resource": {
        "resourceType": "Coverage",
        "status": "active",
        "identifier": [{
          "type": { "coding": [{ "code": "MB" }] },
          "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
          "value": "202818102"
        }]
      }
    },
    {
      "name": "Consent",
      "resource": {
        "resourceType": "Consent",
        "status": "active",
        "policy": [{
          "uri": "http://hl7.org/fhir/us/davinci-hrex/StructureDefinition-hrex-consent.html#regular"
        }],
        "provision": {
          "type": "permit",
          "period": { "start": "2021-01-01", "end": "2023-01-01" }
        }
      }
    }
  ]
};

return (
<div className="container">
<Card className="card-background"> <Card.Body>
<blockquote className="blockquote mb-0">
<h1 className="text-header">Payer-to-Payer (IOX as new payer)</h1><br></br>
<p>When IOX is the requesting (new) payer. A member enrolls with IOX, names their previous payer, and consents to data exchange. IOX then calls that old payer&apos;s FHIR APIs to match the member and pull prior Patient, Coverage, ExplanationOfBenefit, and clinical data into IOX.</p>
<p>This page describes what IOX sends to the old payer. The old payer must expose token, <code>$member-match/$bulk-member-match</code>, Group <code>$export</code>, and export job status. See <strong>Payer-to-Payer (IOX as old Payer)</strong> for the reverse role, when another payer calls IOX.</p>
</blockquote> </Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h4 className="OldPayerP2P-heading">How the flow starts</h4>
<ol className="OldPayerP2P-list">
<li>The old payer is registered in IOX (admin) with client credentials and FHIR URLs. Status must be <strong>Client Registration Completed</strong>.</li>
<li>The member registers in IOX and, on old-payer data exchange, agrees to share prior coverage data.</li>
<li>The member enters previous-payer details (payer name, member number / MB, coverage period).</li>
<li>IOX stores the request and later jobs call the old payer automatically. The member does not call FHIR APIs.</li>
</ol>
<h4 className="OldPayerP2P-heading">Old payer configuration IOX stores</h4>
<p>Each old payer record has <code>clientTokenDetails</code>. IOX uses these URLs at runtime (they are not hard-coded to one host).</p>
<Table striped bordered hover>
<thead>
<tr>
<th>Field</th>
<th>Used for</th>
</tr>
</thead>
<tbody>
<tr>
<td>tokenUrl</td>
<td>Client-credentials access token</td>
</tr>
<tr>
<td>memberMatchUrl</td>
<td>POST FHIR Parameters to $member-match (typically .../R4/Patient/$member-match)</td>
</tr>
<tr>
<td>exportJobUrl</td>
<td>GET .../Group/&#123;groupId&#125;/$export</td>
</tr>
<tr>
<td>processJobUrl</td>
<td>GET export job status (.../job/&#123;jobId&#125;)</td>
</tr>
<tr>
<td>clientId / clientSecret</td>
<td>OAuth client for the old payer</td>
</tr>
<tr>
<td>scope</td>
<td>Requested on the token. Configure <code>Provided old payer scope</code>.</td>
</tr>
<tr>
<td>clientAuthenticationMethod</td>
<td>client_secret_post (default) or client_secret_basic</td>
</tr>
</tbody>
</Table>
</Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h4 className="OldPayerP2P-heading">Access token (IOX calling the old payer)</h4>
<p>IOX uses <strong>client_credentials</strong> against the old payer <code>tokenUrl</code>. Scope sent is the value stored on that payer (use <code>provided old payer scope</code>). The token is reused until near expiry, then refreshed.</p>
<Table striped bordered hover>
<tbody>
<tr>
<td>grant_type</td>
<td>client_credentials</td>
</tr>
<tr>
<td>scope</td>
<td>Provided old payer scope</td>
</tr>
<tr>
<td>Authorization</td>
<td>Bearer ACCESS_TOKEN on every old-payer FHIR call</td>
</tr>
</tbody>
</Table>
<p>Member opt-in is collected in IOX (registration + FHIR Consent on the match body). The token used for match and export is the payer client token, not a member authorization-code token.</p>
</Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h1 className="text-header">Calls IOX makes to the old payer</h1>
<p>These run from IOX P2P Target Exchange (service + Camel jobs). Same FHIR steps as inbound old-payer export, but IOX is the client. After files are sent to Kafka, IOX waits for persist receipts before marking the exchange complete.</p>
<ol className="OldPayerP2P-list">
<li>POST &#123;memberMatchUrl&#125; — HRex $member-match or $bulk-member-match</li>
<li>GET &#123;exportJobUrl&#125;/&#123;groupId&#125;/$export</li>
<li>GET &#123;processJobUrl&#125;/&#123;jobId&#125;</li>
<li>GET each output[] NDJSON file URL — Kafka 200 queues the save</li>
<li>GET api/esb/p2p/execute/processPersistReceipts — close Completed or Failed from receipts</li>
</ol>

<h4 className="OldPayerP2P-heading">1. Member Match</h4>
<div>
<codeblock className="accesstoken-code"> POST</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">&#123;memberMatchUrl&#125;</codeblock>
</div>
<br/>
<Table striped bordered hover>
<tbody>
<tr>
<td>Authorization</td>
<td>Bearer ACCESS_TOKEN</td>
</tr>
<tr>
<td>Content-Type</td>
<td>application/json</td>
</tr>
</tbody>
</Table>
<p>IOX builds Parameters from member demographics and the stored old-payer MB:</p>
<ul className="OldPayerP2P-list">
<li><code>MemberPatient</code> — given, family, birthDate, MB identifier</li>
<li><code>CoverageToMatch</code> — active Coverage with the same MB, coverage period, optional group/plan</li>
<li><code>Consent</code> — status=active, HRex #regular, provision.type=permit, period from the old coverage dates</li>
<li><code>NewCoverage</code> — added when IOX already has the member&apos;s new coverage</li>
</ul>
<h4 className="OldPayerP2P-heading">Sample Body</h4>
<pre style={codestyle}>
<code className="prettyprint">
{JSON.stringify(memberMatchBody,null,'  ')}
</code>
</pre>
<p>Success must return HRex Parameters with identifier type <code>UMB</code>, <code>Patient/&#123;id&#125;</code>, and <code>groupId</code>. IOX then sets workflow <strong>Ready for Data Exchange</strong> and stores that groupId. No unique match is recorded as <strong>Member Match Failed</strong>.</p>

<h4 className="OldPayerP2P-heading">2. Export Kickoff</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">&#123;exportJobUrl&#125;/&#123;groupId&#125;/$export</codeblock>
</div>
<p>No body. Bearer token required. IOX reads the job id from the OperationOutcome details text (<code>/job/&#123;jobId&#125;</code>) and sets workflow <strong>Member Export Initiated</strong>.</p>

<h4 className="OldPayerP2P-heading">3. Export Status</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">&#123;processJobUrl&#125;/&#123;jobId&#125;</codeblock>
</div>
<p>IOX polls until status is Successful / Completed, running=0, failed=0, and <code>output[]</code> has file URLs.</p>

<h4 className="OldPayerP2P-heading">4. File Download</h4>
<p>GET each <code>output[].url</code> with Bearer token and Accept <code>application/fhir+ndjson</code>. IOX posts Patient, Coverage, ExplanationOfBenefit, and clinical resources to Kafka. HTTP 200 from Kafka means <strong>QUEUED</strong>, not saved in Mongo yet. Workflow is set to <strong>Data Exchange Processing</strong>. Receipts are stored on <code>P2pFhirPersistReceipt</code> by <code>saveAttemptId</code> + resource type + resource id.</p>

<h4 className="OldPayerP2P-heading">5. Persist receipts (complete the exchange)</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">api/esb/p2p/execute/processPersistReceipts</codeblock>
</div><br/>
<p>The job selects payers in <strong>Data Exchange Processing</strong> and compares persist receipts to <code>expectedSaveCount</code> for that <code>saveAttemptId</code>:</p>
<ul className="OldPayerP2P-list">
<li>saved count equals expected — <strong>Data Exchange Completed.</strong></li>
<li>any ERROR, or saved count do not match expected count — <strong>Data Exchange Failed.</strong></li>
<li>still waiting — leave Processing and retry next run.</li>
</ul>
</Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h4 className="OldPayerP2P-heading">Workflow status</h4>
<Table striped bordered hover>
<thead>
<tr>
<th>Status</th>
<th>Meaning</th>
</tr>
</thead>
<tbody>
<tr>
<td>Ready for Member Consent</td>
<td>Member named an old payer; consent email / opt-in still in progress</td>
</tr>
<tr>
<td>Ready for Member Match</td>
<td>Eligible for the match job</td>
</tr>
<tr>
<td>Member Match Failed</td>
<td>Old payer did not return a unique UMB + Patient id + groupId</td>
</tr>
<tr>
<td>Ready for Data Exchange</td>
<td>Match succeeded; export job will run</td>
</tr>
<tr>
<td>Member Export Initiated</td>
<td>Group/$export accepted; job id stored</td>
</tr>
<tr>
<td>Data Exchange Processing</td>
<td>NDJSON sent to Kafka (QUEUED). Waiting for persist receipts</td>
</tr>
<tr>
<td>Data Exchange Completed</td>
<td>expectedSaveCount receipts saved for the saveAttemptId</td>
</tr>
<tr>
<td>Data Exchange Failed</td>
<td>Export, download, persist ERROR, or receipts still short after 24 hours</td>
</tr>
</tbody>
</Table>
<p>Jobs run on a schedule (member match, then export kickoff, then process/download, then persist receipts). Payer status must be <strong>Client Registration Completed</strong> or that old payer is skipped.</p>
<h4 className="OldPayerP2P-heading">What an old payer must support for IOX</h4>
<Table striped bordered hover>
<thead>
<tr>
<th>IOX call</th>
<th>Old payer endpoint</th>
</tr>
</thead>
<tbody>
<tr>
<td>Token</td>
<td>POST tokenUrl, grant_type=client_credentials, scope provided old payer scope</td>
</tr>
<tr>
<td>Match</td>
<td>POST member-match with MemberPatient, CoverageToMatch, Consent</td>
</tr>
<tr>
<td>Export</td>
<td>GET Group/&#123;groupId&#125;/$export</td>
</tr>
<tr>
<td>Status + files</td>
<td>GET job status with output[] NDJSON URLs</td>
</tr>
</tbody>
</Table>
</Card.Body>
</Card>
</div>
);
}
